import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { TextField, Typography } from "@mui/material";
import { Snackbar } from "@mui/material";
import { Paper, Stack } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { del, get, post } from "../../../../Services/tokenConfig";
import LoadingVulpes from "../../../../Styles/Loader/loading";
import { StyledTableCell, StyledTableCellRight, StyledTableHead } from "../../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField } from "../../../../Styles/theme/customThemeprovider";
import { func_print } from "../../../../Func_genericas/func_print";
import { useLocation } from "react-router-dom";
import BasicPopover from "../../../../Components/Popover";
import { BarraDeFerramentas } from "../../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import ConfirmDialog from "../../../../Components/CustomDialog/customdialog";
import { IAlteracoesUmCab } from "../../../../Interfaces/anexos/anexo2/alteracoes";
import { Alert } from "../../../../Components/Alert/Alert";
import { TableBody } from "@mui/material";
import { ButtonCadernos } from "../../../../Components/barra-de-ferramentas/ButtonCadernos";
import { AuthContext } from "../../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../../Func_genericas/valores_estaticos";


export const AlteracoesAEfetuarAreaForm = () => {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const is_historico = location.state?.is_historico ?? false;


  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<IAlteracoesUmCab>();
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
  const [obj_anexo_lista_cabecalho, set_obj_anexo_lista_cabecalho] = useState<IAlteracoesUmCab[]>([]);
  const [flag_criar_novo_anexo, set_flag_criar_novo_anexo] = React.useState(false);
  const [flag_criar_novo_cabecalho, set_flag_criar_novo_cabecalho] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handle_close_adicionar_anexo_cabecalho()
    set_obj_anexo_cabecalho(undefined)


    set_obj_anexo_cabecalho(undefined)

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type, checked } = event.target;
    let aux_obj_anexo: any = obj_anexo_cabecalho === undefined ? {} : obj_anexo_cabecalho
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo_cabecalho(aux_obj_anexo);

    } else {

      set_obj_anexo_cabecalho((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
  };

  const handle_delete_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete__reg_anexo_dois_alteracoes_cabecalho/${obj_anexo_cabecalho?.id_alteracoes_cabecalho}`
      );
      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista_cabecalho.filter((el) => {
          if (el.id_alteracoes_cabecalho !== obj_anexo_cabecalho?.id_alteracoes_cabecalho) {
            return el
          }
        })
        set_obj_anexo_lista_cabecalho(lista_aux === undefined ? [] : lista_aux)
        setMessage("Registo eliminado com sucesso!");
        set_obj_anexo_cabecalho(undefined)

        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };

  const handle_create_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "new_reg_anexo_dois_alteracoes_cabecalho", {
        payload: {
          id_alteracoes_cabecalho: 0,
          ano: obj_anexo_cabecalho?.ano === undefined ? '' : obj_anexo_cabecalho?.ano,
          mes_um: obj_anexo_cabecalho?.mes_um === undefined ? '' : obj_anexo_cabecalho?.mes_um,
          mes_dois: obj_anexo_cabecalho?.mes_dois === undefined ? '' : obj_anexo_cabecalho?.mes_dois,
          mes_tres: obj_anexo_cabecalho?.mes_tres === undefined ? '' : obj_anexo_cabecalho?.mes_tres,
          mes_quatro: obj_anexo_cabecalho?.mes_quatro === undefined ? '' : obj_anexo_cabecalho?.mes_quatro,
          camp_um: obj_anexo_cabecalho?.camp_um === undefined ? '' : obj_anexo_cabecalho?.camp_um,
          camp_dois: obj_anexo_cabecalho?.camp_dois === undefined ? '' : obj_anexo_cabecalho?.camp_dois,
          camp_tres: obj_anexo_cabecalho?.camp_tres === undefined ? '' : obj_anexo_cabecalho?.camp_tres,
          camp_quatro: obj_anexo_cabecalho?.camp_quatro === undefined ? '' : obj_anexo_cabecalho?.camp_quatro,
          camps_um: obj_anexo_cabecalho?.camps_um === undefined ? '' : obj_anexo_cabecalho?.camps_um,
          camps_dois: obj_anexo_cabecalho?.camps_dois === undefined ? '' : obj_anexo_cabecalho?.camps_dois,
          camps_tres: obj_anexo_cabecalho?.camps_tres === undefined ? '' : obj_anexo_cabecalho?.camps_tres,
          camps_quatro: obj_anexo_cabecalho?.camps_quatro === undefined ? '' : obj_anexo_cabecalho?.camps_quatro,
          fundamentacao: obj_anexo_cabecalho?.fundamentacao === undefined ? '' : obj_anexo_cabecalho?.fundamentacao,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: ''
        }
      });

      if (res.status === 200) {
        set_obj_anexo_lista_cabecalho((old) => [...old, res.data.result])
        set_obj_anexo_cabecalho(undefined);
        set_flag_criar_novo_cabecalho(false)
        set_flag_editado(false)

        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);


        set_flag_criar_novo_anexo(false);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);

      }

      setIsLoading(false);
    } catch (error) {
      func_print("handle_create_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);

    }
  };

  const handle_update_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "update_reg_anexo_alteracoes_cabecalho", { payload: obj_anexo_cabecalho });

      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista_cabecalho.map((el) => {
          if (el.id_alteracoes_cabecalho !== obj_anexo_cabecalho?.id_alteracoes_cabecalho) {
            return el
          } else {
            return res.data.result
          }
        })
        set_flag_editado(false)

        set_obj_anexo_lista_cabecalho(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho(undefined);
        set_flag_criar_novo_cabecalho(false)

        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("handle_update_anexo", error, true);
      setMessage("Erro ao gravar!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };
  const handle_escolhe_qual_elimina = async () => {
    await handle_delete_anexo_cabecalho()
  }


  const get_info = async () => {
    try {
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_anexo_dois_alteracoes_cabecalho_rosto/${location.state.id_rosto}`
      );

      if (res_cabecalho.status === 200) {
        if (res_cabecalho.data.result.length !== 0) {
          set_obj_anexo_lista_cabecalho(res_cabecalho.data.result[0]);
        }
      } else {
        setMessage("Erro a carregar informação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handle_close_adicionar_anexo_cabecalho = () => {
    set_obj_anexo_cabecalho(undefined)
    set_flag_criar_novo_cabecalho(false)
  }

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);


  return (
    <>
      {isLoading ? (
        <LoadingVulpes />
      ) : (
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}

            </Alert>
          </Snackbar>
          <table style={{ width: "75%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={4}
                  sx={{ fontWeight: 600, fontSize: 16, fontFamily: "candara" }}
                >
                  <Stack direction="row" justifyContent="left">
                    6 - Alterações a efetuar no maneio do efetivo pecuário em
                    pastoreio
                    <BasicPopover
                      text={
                        "Preencher os campos infra em complemento da informação disponibilizada no quadro 2, quando aplicável.\n\nNo caso do regime ecológico «maneio da pastagem permanente», no preenchimento dos campos deve ser considerado o período de 3 anos.\n\nNo caso da intervenção agroambiental «conservação do solo - pastagens biodiversas, no preenchimento dos campos deve ser considerado o período de 5 anos."
                      }
                    />
                  </Stack>
                </TableCell>
                <TableCell colSpan={3}>
                  <Stack direction="row" sx={{ justifyContent: "end" }}>
                    {is_historico === true ? <></> :

                      <BarraDeFerramentas
                        mostrarBotaoNovo
                        textoBotaoNovo="Adicionar cabeçalho"
                        aoClicarNovo={() => set_flag_criar_novo_cabecalho(true)}
                      />}
                  </Stack>
                </TableCell>
              </TableRow>
            </TableHead>

            {flag_criar_novo_cabecalho && (
              <>
                <TableRow>
                  <TableCell rowSpan={2} sx={{ width: 300 }}></TableCell>

                  <StyledTableHead colSpan={4}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography
                        sx={{ paddingRight: 2, fontFamily: "candara" }}
                      >
                        Ano:
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          views={["year"]}
                          label={
                            <Typography fontFamily="candara" fontSize={14}>
                              Selecionar ano
                            </Typography>
                          }
                          value={obj_anexo_cabecalho?.ano === undefined ? null : dayjs(obj_anexo_cabecalho?.ano)}

                          onChange={(newValue) => {
                            onInputEditTableChange_cabecalho({
                              target: {
                                name: "ano",
                                value: newValue ? newValue.format("YYYY") : "",
                              },
                            });
                          }}
                          minDate={dayjs("2010")}
                          slots={{
                            textField: textFieldProps => <TextField {...textFieldProps} />
                          }}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </StyledTableHead>
                  <StyledTableHead >
                    Ações
                  </StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead>
                    <CustomTextField
                      name="mes_um"
                      value={obj_anexo_cabecalho?.mes_um === undefined ? '' : obj_anexo_cabecalho?.mes_um}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="mes_dois"
                      value={obj_anexo_cabecalho?.mes_dois === undefined ? '' : obj_anexo_cabecalho?.mes_dois}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="mes_tres"
                      value={obj_anexo_cabecalho?.mes_tres === undefined ? '' : obj_anexo_cabecalho?.mes_tres}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="mes_quatro"
                      value={obj_anexo_cabecalho?.mes_quatro === undefined ? '' : obj_anexo_cabecalho?.mes_quatro}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableHead>
                  <StyledTableCell rowSpan={4}>
                    <ButtonCadernos
                      mostrarBotaoGravar
                      aoClicarGravar={() => handle_create_anexo_cabecalho()}
                      mostrarBotaoCancelar
                      aoClicarCancelar={() => {
                        if (flag_editado) {
                          set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                          handle_close_adicionar_anexo_cabecalho()
                        }
                      }}
                    />
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell>
                    Rotação das subparcelas/zonas homogéneas
                    <BasicPopover
                      text={
                        "Entende-se por «rotação das subparcelas/zonas homogéneas» a rotatividade das áreas de pastagem permanente para pastoreio."
                      }
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camp_um"
                      value={obj_anexo_cabecalho?.camp_um === undefined ? '' : obj_anexo_cabecalho?.camp_um}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camp_dois"
                      value={obj_anexo_cabecalho?.camp_dois === undefined ? '' : obj_anexo_cabecalho?.camp_dois}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camp_tres"
                      value={obj_anexo_cabecalho?.camp_tres === undefined ? '' : obj_anexo_cabecalho?.camp_tres}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camp_quatro"
                      value={obj_anexo_cabecalho?.camp_quatro === undefined ? '' : obj_anexo_cabecalho?.camp_quatro}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell>
                    Espécies e respetivos n.º de CN em pastoreio
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camps_um"
                      value={obj_anexo_cabecalho?.camps_um === undefined ? '' : obj_anexo_cabecalho?.camps_um}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camps_dois"
                      value={obj_anexo_cabecalho?.camps_dois === undefined ? '' : obj_anexo_cabecalho?.camps_dois}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camps_tres"
                      value={obj_anexo_cabecalho?.camps_tres === undefined ? '' : obj_anexo_cabecalho?.camps_tres}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="camps_quatro"
                      value={obj_anexo_cabecalho?.camps_quatro === undefined ? '' : obj_anexo_cabecalho?.camps_quatro}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell>
                    Fundamentação/ observações
                    <BasicPopover
                      text={
                        "Campo descritivo onde deve ser registada a fundamentação técnica para as intervenções propostas nos campos anteriores."
                      }
                    />
                  </StyledTableCell>
                  <StyledTableCell colSpan={4}>
                    <CustomTextField
                      name="fundamentacao"
                      value={obj_anexo_cabecalho?.fundamentacao === undefined ? '' : obj_anexo_cabecalho?.fundamentacao}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                  </StyledTableCell>
                </TableRow>
              </>
            )}

            {obj_anexo_lista_cabecalho?.length === 0 ? <></> :
              obj_anexo_lista_cabecalho?.map((cab, key) => {
                if (obj_anexo_cabecalho?.id_alteracoes_cabecalho !== cab.id_alteracoes_cabecalho) {

                  return (
                    <TableBody key={key}>
                      <TableRow>
                        <TableCell ></TableCell>

                      </TableRow>
                      <TableRow>
                        <TableCell rowSpan={2} sx={{ width: 300 }}></TableCell>

                        <StyledTableHead colSpan={4}>
                          Ano: {cab.ano}
                        </StyledTableHead>
                        <StyledTableHead>
                          Ações
                        </StyledTableHead>
                      </TableRow>
                      <TableRow>


                        <StyledTableHead>
                          {cab.mes_um}
                          <BasicPopover
                            text={
                              "Campo editável nos casos em que a rotação do efetivo apresenta outro período temporal (ex. mensal, bimensal, etc…)."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableHead>
                          {cab.mes_dois}
                          <BasicPopover
                            text={
                              "Campo editável nos casos em que a rotação do efetivo apresenta outro período temporal (ex. mensal, bimensal, etc…)."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableHead>
                          {cab.mes_tres}
                          <BasicPopover
                            text={
                              "Campo editável nos casos em que a rotação do efetivo apresenta outro período temporal (ex. mensal, bimensal, etc…)."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableHead>
                          {cab.mes_quatro}
                          <BasicPopover
                            text={
                              "Campo editável nos casos em que a rotação do efetivo apresenta outro período temporal (ex. mensal, bimensal, etc…)."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableHead rowSpan={4}>
                          {is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoEditar
                              aoClicarEditar={() => {
                                set_obj_anexo_cabecalho(cab)
                              }}
                              mostrarBotaoApagar
                              aoClicarApagar={() => {
                                set_obj_anexo_cabecalho(cab)
                                set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                              }}
                            />}
                        </StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          Rotação das subparcelas/zonas homogéneas
                          <BasicPopover
                            text={
                              "Entende-se por «rotação das subparcelas/zonas homogéneas» a rotatividade das áreas de pastagem permanente para pastoreio."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableCellRight>
                          {cab.camp_um}
                          <BasicPopover
                            text={
                              "Identificar que subparcelas ou zonas homogéneas devem ser pastoreadas neste período do ano identificado no campo supra."
                            }
                          />
                        </StyledTableCellRight>
                        <StyledTableCellRight>
                          {cab.camp_dois}

                          <BasicPopover
                            text={
                              "Identificar que subparcelas ou zonas homogéneas devem ser pastoreadas neste período do ano identificado no campo supra."
                            }
                          />
                        </StyledTableCellRight>
                        <StyledTableCellRight>
                          {cab.camp_tres}

                          <BasicPopover
                            text={
                              "Identificar que subparcelas ou zonas homogéneas devem ser pastoreadas neste período do ano identificado no campo supra."
                            }
                          />
                        </StyledTableCellRight>
                        <StyledTableCellRight>
                          {cab.camp_quatro}

                          <BasicPopover
                            text={
                              "Identificar que subparcelas ou zonas homogéneas devem ser pastoreadas neste período do ano identificado no campo supra."
                            }
                          />
                        </StyledTableCellRight>

                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          Espécies e respetivos n.º de CN em pastoreio
                        </StyledTableHead>
                        <StyledTableCellRight>
                          {cab.camps_um}

                          <BasicPopover
                            text={
                              "Identificar por subparcelas/zonas homogéneas que espécie pecuária e n.º de Cabeças Normais (CN) devem pastorear as superfícies em causa neste período.\n\nNa conversão de cabeças naturais em cabeças normais devem ser utilizados os coeficientes previstos no Anexo I da Portaria n.º 54-C/2023 e da Portaria n.º 54-E/2023:\n\nEspécies                                                     Cabeças Normais (CN)\nBovinos com mais de 2 anos ............................. 1\nBovinos de 6 meses a 2 anos ........................... 0,6\nBovinos com menos de 6 meses ....................... 0,4\nOvinos com mais de 1 ano ............................... 0,15\nCaprinos com mais de 1 ano ............................ 0,15\nPorcas reprodutoras > 50kg ........................... 0,5\nOutros suínos (com mais de 3 meses) .............. 0,3\nEquídeos com mais de 6 meses ......................... 1"
                            }
                          />
                        </StyledTableCellRight>
                        <StyledTableCellRight>
                          {cab.camps_dois}

                          <BasicPopover
                            text={
                              "Identificar por subparcelas/zonas homogéneas que espécie pecuária e n.º de Cabeças Normais (CN) devem pastorear as superfícies em causa neste período.\n\nNa conversão de cabeças naturais em cabeças normais devem ser utilizados os coeficientes previstos no Anexo I da Portaria n.º 54-C/2023 e da Portaria n.º 54-E/2023:\n\nEspécies                                                     Cabeças Normais (CN)\nBovinos com mais de 2 anos ............................. 1\nBovinos de 6 meses a 2 anos ........................... 0,6\nBovinos com menos de 6 meses ....................... 0,4\nOvinos com mais de 1 ano ............................... 0,15\nCaprinos com mais de 1 ano ............................ 0,15\nPorcas reprodutoras > 50kg ........................... 0,5\nOutros suínos (com mais de 3 meses) .............. 0,3\nEquídeos com mais de 6 meses ......................... 1"
                            }
                          />
                        </StyledTableCellRight>
                        <StyledTableCellRight>
                          {cab.camps_tres}

                          <BasicPopover
                            text={
                              "Identificar por subparcelas/zonas homogéneas que espécie pecuária e n.º de Cabeças Normais (CN) devem pastorear as superfícies em causa neste período.\n\nNa conversão de cabeças naturais em cabeças normais devem ser utilizados os coeficientes previstos no Anexo I da Portaria n.º 54-C/2023 e da Portaria n.º 54-E/2023:\n\nEspécies                                                     Cabeças Normais (CN)\nBovinos com mais de 2 anos ............................. 1\nBovinos de 6 meses a 2 anos ........................... 0,6\nBovinos com menos de 6 meses ....................... 0,4\nOvinos com mais de 1 ano ............................... 0,15\nCaprinos com mais de 1 ano ............................ 0,15\nPorcas reprodutoras > 50kg ........................... 0,5\nOutros suínos (com mais de 3 meses) .............. 0,3\nEquídeos com mais de 6 meses ......................... 1"
                            }
                          />
                        </StyledTableCellRight>
                        <StyledTableCellRight>
                          {cab.camps_quatro}

                          <BasicPopover
                            text={
                              "Identificar por subparcelas/zonas homogéneas que espécie pecuária e n.º de Cabeças Normais (CN) devem pastorear as superfícies em causa neste período.\n\nNa conversão de cabeças naturais em cabeças normais devem ser utilizados os coeficientes previstos no Anexo I da Portaria n.º 54-C/2023 e da Portaria n.º 54-E/2023:\n\nEspécies                                                     Cabeças Normais (CN)\nBovinos com mais de 2 anos ............................. 1\nBovinos de 6 meses a 2 anos ........................... 0,6\nBovinos com menos de 6 meses ....................... 0,4\nOvinos com mais de 1 ano ............................... 0,15\nCaprinos com mais de 1 ano ............................ 0,15\nPorcas reprodutoras > 50kg ........................... 0,5\nOutros suínos (com mais de 3 meses) .............. 0,3\nEquídeos com mais de 6 meses ......................... 1"
                            }
                          />
                        </StyledTableCellRight>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          Fundamentação/ observações
                          <BasicPopover
                            text={
                              "Campo descritivo onde deve ser registada a fundamentação técnica para as intervenções propostas nos campos anteriores."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableCell colSpan={4}>

                          {cab.fundamentacao}

                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )
                } else {
                  return (
                    <TableBody key={key}>

                      <TableRow>
                        <TableCell rowSpan={2} sx={{ width: 300 }}></TableCell>
                        <StyledTableHead colSpan={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Typography
                              sx={{ paddingRight: 2, fontFamily: "candara" }}
                            >
                              Ano:
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                views={["year"]}
                                label={
                                  <Typography fontFamily="candara" fontSize={14}>
                                    Selecionar ano
                                  </Typography>
                                }
                                value={obj_anexo_cabecalho?.ano === undefined ? null : dayjs(obj_anexo_cabecalho?.ano)}
                                onChange={(newValue) => {
                                  onInputEditTableChange_cabecalho({
                                    target: {
                                      name: "ano",
                                      value: newValue
                                        ? newValue.format("YYYY")
                                        : "",
                                    },
                                  });
                                }}
                                minDate={dayjs("2010")}
                                slots={{
                                  textField: textFieldProps => <TextField {...textFieldProps} />
                                }}
                              />
                            </LocalizationProvider>
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead>
                          Ações
                        </StyledTableHead>

                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          <CustomTextField
                            name="mes_um"
                            value={obj_anexo_cabecalho?.mes_um === undefined ? '' : obj_anexo_cabecalho?.mes_um}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableHead>
                        <StyledTableHead>
                          <CustomTextField
                            name="mes_dois"
                            value={obj_anexo_cabecalho?.mes_dois === undefined ? '' : obj_anexo_cabecalho?.mes_dois}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableHead>
                        <StyledTableHead>
                          <CustomTextField
                            name="mes_tres"
                            value={obj_anexo_cabecalho?.mes_tres === undefined ? '' : obj_anexo_cabecalho?.mes_tres}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableHead>
                        <StyledTableHead>
                          <CustomTextField
                            name="mes_quatro"
                            value={obj_anexo_cabecalho?.mes_quatro === undefined ? '' : obj_anexo_cabecalho?.mes_quatro}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableHead>
                        <StyledTableHead rowSpan={4}>
                          <ButtonCadernos
                            mostrarBotaoGravar
                            aoClicarGravar={() => handle_update_anexo_cabecalho()}
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                set_obj_anexo_cabecalho(undefined)
                              }
                            }}
                          />
                        </StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell>
                          Rotação das subparcelas/zonas homogéneas
                          <BasicPopover
                            text={
                              "Entende-se por «rotação das subparcelas/zonas homogéneas» a rotatividade das áreas de pastagem permanente para pastoreio."
                            }
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camp_um"
                            value={obj_anexo_cabecalho?.camp_um === undefined ? '' : obj_anexo_cabecalho?.camp_um}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camp_dois"
                            value={obj_anexo_cabecalho?.camp_dois === undefined ? '' : obj_anexo_cabecalho?.camp_dois}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camp_tres"
                            value={obj_anexo_cabecalho?.camp_tres === undefined ? '' : obj_anexo_cabecalho?.camp_tres}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camp_quatro"
                            value={obj_anexo_cabecalho?.camp_quatro === undefined ? '' : obj_anexo_cabecalho?.camp_quatro}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell>
                          Espécies e respetivos n.º de CN em pastoreio
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camps_um"
                            value={obj_anexo_cabecalho?.camps_um === undefined ? '' : obj_anexo_cabecalho?.camps_um}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camps_dois"
                            value={obj_anexo_cabecalho?.camps_dois === undefined ? '' : obj_anexo_cabecalho?.camps_dois}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camps_tres"
                            value={obj_anexo_cabecalho?.camps_tres === undefined ? '' : obj_anexo_cabecalho?.camps_tres}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camps_quatro"
                            value={obj_anexo_cabecalho?.camps_quatro === undefined ? '' : obj_anexo_cabecalho?.camps_quatro}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell>
                          Fundamentação/ observações
                          <BasicPopover
                            text={
                              "Campo descritivo onde deve ser registada a fundamentação técnica para as intervenções propostas nos campos anteriores."
                            }
                          />
                        </StyledTableCell>
                        <StyledTableCell colSpan={4}>
                          <CustomTextField
                            name="fundamentacao"
                            value={obj_anexo_cabecalho?.fundamentacao === undefined ? '' : obj_anexo_cabecalho?.fundamentacao}
                            onChange={onInputEditTableChange_cabecalho}
                          />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )
                }
              }
              )}
          </table>
          <ConfirmDialog
            open={open_dialog_tem_a_certeza_que_quer_eliminar}
            onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
            onConfirm={handle_escolhe_qual_elimina}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </TableContainer >
      )}
    </>
  );
};
